import React, { useEffect, useState } from "react";
import Numpad from "../NumPad/NumPad";

const CreditCardPaymentMethod = ({
  total,
  onAmountChange,
  enteredAmountCreditCard,
  maxAmount,
}: any) => {
  const [givenAmountCash, setGivenAmountCash] = useState<string | null>(null);

  // const containsOnlyNumbers = (str: string) => !/[^0-9.]/.test(str) && /^\d+(\.\d+)?$/.test(str);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Allow the input if it's a valid number or just a dot.
    if (/^\d*\.?\d*$/.test(value)) {
      if (value === "") {
        setGivenAmountCash(value); // Handle empty input
        onAmountChange(null);
        return;
      }
      const parsed = Number(value);
      const clamped =
        !isNaN(parsed) && typeof maxAmount === "number"
          ? Math.min(parsed, Math.max(0, maxAmount))
          : parsed;
      setGivenAmountCash(isNaN(clamped) ? value : String(clamped)); // Store the (possibly clamped) value
      onAmountChange(isNaN(clamped) ? null : clamped);
    }
  };
  const handleSetTotalAsCash = () => {
    const formattedTotal = total?.toFixed(3);
    setGivenAmountCash(formattedTotal);
    onAmountChange(formattedTotal);
  };
  const handleResetTotalAsCash = () => {
    setGivenAmountCash("0");
    onAmountChange(0);
  };
  useEffect(() => {
    setGivenAmountCash(null);
  }, [total]);

  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form
            className="form-inline search-full form-inline search"
            role="search"
          >
            <div className="search-bar" style={{ marginBottom: "7px" }}>
              <div className="relative w-full">
                <input
                  type="text"
                  // style={{ width: "80%" }}
                  className="form-control search-form-control ml-lg-auto pr-16" // Add padding to the right for the button
                  placeholder="Montant"
                  value={
                    enteredAmountCreditCard > 0
                      ? enteredAmountCreditCard
                      : givenAmountCash !== null
                      ? givenAmountCash
                      : givenAmountCash
                  }
                  onChange={handleAmountChange}
                />
                
                {/* {!givenAmountCash ? (
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ background: "#009688", color: "#fff" }}
                    onClick={handleSetTotalAsCash} // Call the handler here
                  >
                    <svg
                      style={{ position: "unset", margin: 0 }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="#ffffff"
                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                      />
                    </svg>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ background: "#009688", color: "#fff" }}
                    onClick={handleResetTotalAsCash} // Call the handler here
                  >
                    x
                  </button>
                )} */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreditCardPaymentMethod;
